import { createFileRoute } from '@tanstack/react-router';
import { PageBody, Spinner } from '@wundo/ui';
import { fetchCurrentUser } from '@wundo/client/auth.ts';
import { NotFoundPage } from '@/components/NotFoundPage.tsx';
import { ColleagueDetailPage } from '@/components/team/ColleagueDetailPage.tsx';
import { usePublishChatAnchor } from '@/lib/chatAnchor.ts';
import { oneOnOneColleagueQuery } from '@/lib/colleagues.ts';
import { loadOrNotFound } from '@/lib/loadOrNotFound.ts';
import { m } from '@/paraglide/messages.js';

export const Route = createFileRoute('/_app/team/$colleagueId')({
  loader: ({ context, params }) =>
    loadOrNotFound(async () => {
      const user = await context.queryClient.ensureQueryData({
        queryKey: ['currentUser'],
        queryFn: fetchCurrentUser,
      });
      await context.queryClient.ensureQueryData(
        oneOnOneColleagueQuery(user.id, params.colleagueId),
      );
    }),
  /* Shown straight away: the page has nothing to say until the colleague is loaded. */
  pendingComponent: ColleaguePending,
  pendingMs: 0,
  pendingMinMs: 0,
  notFoundComponent: NotFoundPage,
  component: ColleagueRoute,
});

function ColleaguePending() {
  return (
    <PageBody>
      <p className='flex items-center gap-2 text-base text-ink-muted'>
        <Spinner />
        {m.colleague_loading()}
      </p>
    </PageBody>
  );
}

function ColleagueRoute() {
  const { colleagueId } = Route.useParams();
  usePublishChatAnchor({ type: 'person', id: colleagueId });

  return <ColleagueDetailPage colleagueId={colleagueId} />;
}
